import { AccordionResidencyPermit } from 'shell/view-models/accordion-residency-permit';
import { ResidencePermit } from 'shell/models/person/residence-permit';
import { Municipality } from 'shell/models/person/shared';

export const transformResidencyPermit = (
  values: AccordionResidencyPermit | undefined
): ResidencePermit | undefined => {
  if (!values) {
    return undefined;
  }

  const comune: Municipality | undefined =
    values?.municipality?.description || values?.province || values?.location
      ? {
          nomeComune: values?.municipality?.description || undefined,
          codiceIstat: values?.municipality?.id || undefined,
          siglaProvinciaIstat: values?.municipality?.province || values?.province || undefined,
          descrizioneLocalita: values?.location || undefined,
        }
      : undefined;

  const result: ResidencePermit | undefined = values
    ? {
        numeroSoggiorno: values?.number || undefined,
        tipoSoggiorno: values?.type || undefined,
        noteSoggiorno: values?.note || undefined,
        dataRilascio: values?.releaseDate?.toFormat('yyyy-MM-dd') || undefined,
        dataScadenza: values?.expirationDate?.toFormat('yyyy-MM-dd') || undefined,
        questuraRilascioSoggiorno: values?.policeForceRelease || undefined,
        comune: comune || undefined,
        numeroPassaporto: values?.passportNumber || undefined,
      }
    : undefined;

  return result;
};
